<template>
  <div>
    <CustomerSales ref="onOpenSale" />
    <Sidebar
      :onChange="onChangeSidebar"
      :width="500"
      id="payment-sidebar"
      title="Payment"
      right
    >
      <b-tabs content-class="mt-3" fill v-model="tab">
        <b-tab title="Payment" active>
          <div class="px-3 py-1">
            <div @click="onOpenCustomerSalesModal()">
              <b-alert
                v-if="customer_cash_pending_sales.length != 0"
                show
                variant="warning"
                >{{ customer_cash_pending_sales.number_of_sales }} receipts are
                pending in this customer's account. ({{
                  cashBalance(
                    customer_cash_pending_sales.total_amount -
                      customer_cash_pending_sales.paid_amount
                  )
                }})</b-alert
              >
            </div>
            <b-row class="">
              <b-col cols="12" class="mb-2">
                <b-input-group size="sm" prepend="Sale Type" class="mb-2">
                  <b-form-select
                    size="sm"
                    v-model="GetSaleType"
                    :options="saleTypes"
                    @change="onChangeSaleType"
                    :disabled="isSalesTypeDisabled"
                  ></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>
            <!-- <hr class="mt-0" /> -->
            <b-row class="">
              <b-col cols="12">
                <ul class="list-group list-group-flush mg-b-0 tx-13">
                  <li
                    class="
                      subtotal_area
                      list-group-item
                      pd-x-0
                      d-flex
                      justify-content-between
                      bottom-line
                      py-2
                    "
                  >
                    <span class="tx-medium tx-22 font-weight-bold font-poppins"
                      >Sub-total</span
                    >
                    <span class="tx-medium tx-22 font-weight-bold font-poppins">
                      {{
                        (GetDiscountAmount +
                          GetTotalAmount +
                          GetServiceTotalAmount)
                          | amount
                      }}
                    </span>
                  </li>

                  <li
                    class="
                      total_discount_area
                      list-group-item
                      pd-x-0
                      d-flex
                      justify-content-between
                      bottom-line
                      py-2
                    "
                  >
                    <span class="tx-medium tx-22 font-weight-bold font-poppins"
                      >Discount</span
                    >
                    <span class="tx-medium tx-22 font-weight-bold font-poppins">
                      {{ totalDiscount | amount }}
                    </span>
                  </li>
                  <li
                    class="
                      total_amount_area
                      list-group-item
                      pd-x-0
                      d-flex
                      justify-content-between
                      bottom-line
                      py-2
                    "
                  >
                    <span class="tx-medium tx-22 font-weight-bold font-poppins"
                      >Total</span
                    >
                    <span class="tx-medium tx-22 font-weight-bold font-poppins">
                      {{ totalAmountMinusDiscount | amount }}
                    </span>
                  </li>
                </ul>
              </b-col>
            </b-row>

            <b-card class="my-2">
              <div v-for="(paymt, index) in payments" :key="index">
                <!-- <hr v-if="index != 0" class="mt-0" /> -->

                <b-row>
                  <b-col cols="12" class="form-group">
                    <div>
                      <div class="text-left font-poppins mb-2">
                        {{ paymt.payment_type }}
                      </div>
                      <b-input-group :state="amountState" size="md">
                        <b-input-group-prepend>
                          <b-form-select
                            size="sm"
                            v-model="paymt.payment_type"
                            :options="payingByOptions"
                            @change="commitPayments"
                          ></b-form-select>
                        </b-input-group-prepend>
                        <b-form-input
                          class="input_Amount"
                          placeholder="Amount"
                          :state="amountState"
                          type="number"
                          v-model="paymt.amount"
                          @input="calculateBalance(index)"
                          size="sm"
                        ></b-form-input>
                        <template #append>
                          <b-button size="sm" @click="enableDisableNote(index)"
                            ><i class="fa fa-sticky-note mr-1"></i>
                          </b-button>
                          <b-button
                            size="sm"
                            variant="danger"
                            @click="removeOption(index)"
                            v-if="index != 0"
                            ><i class="fa fa-times"></i
                          ></b-button>
                        </template>
                      </b-input-group>
                      <b-row
                        v-show="paymt.payment_type == 'Cheque'"
                        class="mt-2 mb-4"
                      >
                        <b-col cols="12">
                          <b-card>
                            <b-row>
                              <b-col cols="12" class="mb-2">
                                <b-input-group
                                  prepend="Number"
                                  size="sm"
                                  class="mb-2"
                                >
                                  <b-form-input
                                    type="number"
                                    v-model="paymt.cheque_no"
                                    size="sm"
                                  ></b-form-input>
                                </b-input-group>
                              </b-col>
                              <b-col cols="12" class="mb-2">
                                <b-input-group
                                  prepend="Date"
                                  size="sm"
                                  class="mb-2"
                                >
                                  <b-form-datepicker
                                    :button-content-state="false"
                                    v-model="paymt.cheque_date"
                                    size="sm"
                                  ></b-form-datepicker>
                                </b-input-group>
                              </b-col>
                              <b-col cols="12" class="mb-2">
                                <b-input-group
                                  prepend="Bank"
                                  size="sm"
                                  class="mb-2"
                                >
                                  <b-form-input
                                    type="text"
                                    v-model="paymt.cheque_bank"
                                    size="sm"
                                  ></b-form-input>
                                </b-input-group>
                              </b-col>
                              <b-col cols="12" class="mb-2">
                                <b-input-group
                                  prepend="Type"
                                  size="sm"
                                  class="mb-2"
                                >
                                  <b-form-select
                                    size="sm"
                                    v-model="paymt.cheque_type"
                                    :options="chequeTypes"
                                  >
                                  </b-form-select>
                                </b-input-group>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                      </b-row>
                      <div v-if="paymt.haveNote" class="mt-2">
                        <label for="formGroupExampleInput" class="d-block"
                          >Payment Note</label
                        >

                        <b-form-textarea
                          rows="3"
                          max-rows="6"
                          v-model="paymt.payment_note"
                          placeholder="Type something"
                          size="sm"
                          class="mb-2"
                        ></b-form-textarea>
                      </div>
                      <div
                        class="text-right mt-2"
                        v-if="index == payments.length - 1"
                      >
                        <b-button
                          class="btn_add_another_payment"
                          size="sm"
                          variant="warning"
                          @click="addAnotherOption(index)"
                        >
                          <i class="fa fa-plus"> </i>
                          Add Another Payment Method
                        </b-button>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-card>
            <b-row class="mt-2 mb-4">
              <b-col cols="12" class="mb-2">
                <b-input-group size="sm" prepend="Received Amount" class="mb-2">
                  <b-form-input
                    style="text-align: end"
                    type="number"
                    v-model="manualCash"
                    size="lg"
                    placeholder="Amount"
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col cols="12" class="mb-2">
                <b-input-group
                  size="sm"
                  prepend="Additional Discount"
                  class="mb-2"
                >
                  <b-form-input
                    style="text-align: end"
                    type="number"
                    v-model="discountAmount"
                    size="lg"
                    placeholder="Discount"
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col>
                <ul class="list-group list-group-flush mg-b-0 tx-13">
                  <li
                    class="
                      total_discount_area
                      list-group-item
                      pd-x-0
                      d-flex
                      justify-content-between
                      bottom-line
                    "
                  >
                    <span class="tx-medium tx-22 font-weight-bold font-poppins"
                      >Cash Balance</span
                    >
                    <span class="tx-medium tx-22 font-weight-bold font-poppins">
                      {{ finalAmount | amount }}
                    </span>
                  </li>
                </ul>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-btn
                  v-if="GetIsSubmittedSale"
                  class="w-100"
                  size="sm"
                  variant="danger"
                  @click="showCanelModal()"
                  v-b-toggle.payment-sidebar
                >
                  <i class="fa fa-check mr-1"></i> Cancel sale
                </b-btn>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-button
                  :disabled="GetIsSubmittedSale"
                  @click="Payment()"
                  block
                  variant="primary"
                  class="font-poppins font-weight-bold w-100 text-center"
                >
                  <b-spinner
                    v-if="loading"
                    variant="primary"
                    label="Spinning"
                  ></b-spinner>
                  <div v-else>Submit</div>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="Bill">
          <PrintBill :data="payment" />
        </b-tab>
      </b-tabs>
    </Sidebar>

    <b-modal
      @ok="cancelSale()"
      @cancel="hideModal()"
      no-close-on-backdrop
      ref="my-modal"
      size="md"
      title="Sales Cancelation"
      centered
    >
      <form-wrapper>
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="6" lg="12" xl="12">
            <label>Status</label>
            <DropDown
              :isDisabled="true"
              v-model="cancelSaleId"
              :options="salesStatus"
            />
          </b-col>
          <b-col
            class="form-group"
            cols="12"
            xs="12"
            sm="12"
            md="12"
            lg="12"
            xl="12"
          >
            <label>Note</label>
            <b-form-textarea
              id="textarea"
              placeholder="Enter something..."
              rows="3"
              v-model="cancelNote"
              max-rows="6"
            >
            </b-form-textarea>
          </b-col>
        </b-row>
      </form-wrapper>

      <div slot="modal-footer">
        <b-button
          variant="secondary"
          type="submit"
          class="btn btn-primary"
          size="sm"
          @click="hideCanelModal"
          >Cancel
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          size="sm"
          @click="cancelSale()"
          >Ok</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapGetters } from "vuex";

import Sidebar from "@/components/base/Sidebar";
import PickBiller from "@/components/shared/PickBiller";
import PrintBill from "@/components/Payment/PrintBill";
import DropDown from "@/components/base/DropDown";
import CustomerSales from "@/components/CustomerSales";

export default {
  name: "Payment",
  components: {
    PickBiller,
    Sidebar,
    PrintBill,
    DropDown,
    CustomerSales,
  },
  data: () => ({
    cancelSaleId: 1,
    cancelNote: "",
    salesStatus: [{ id: 1, name: "Canceled" }],
    tab: 0,
    loading: false,
    payingByOptions: ["Cash", "Card", "Other"],
    chequeTypes: ["Cash", "Cross"],
    saleTypes: ["Cash", "Credit"],
    payments: [
      {
        amount: 0,
        payment_type: "Cash",
        haveNote: false,
        payment_note: "",
      },
    ],
    customer: {
      amount: 0,
    },
    payment: {
      biller: "",
      sale_note: "",
      staff_note: "",
      // amount: 0,
      // paying_by: { id: 1, name: "Cash" },
      // payment_note: "",
    },
    amountState: null,
  }),

  computed: {
    ...mapGetters("bill", [
      "GetTotalAmount",
      "GetDiscountAmount",
      "GetRoundingAmount",
      "GetProductsCount",
      "isRoundingAmount",
      "roundingAmount",
      "GetCustomerCashAmount",
      "GetCustomerManualAmount",
      "GetSelectedCustomer",
      "GetSaleType",
      "GetIsSubmittedSale",
      "GetAddedSale",
      "GetServiceTotalAmount",
      "GetCustomerDiscountForTotalAmount",
    ]),
    ...mapState("sales", ["customer_cash_pending_sales"]),
    ...mapState("bill", ["isPrint"]),
    manualCash: {
      get: function () {
        return this.GetCustomerManualAmount;
      },
      set(value) {
        this.$store.commit("bill/SET_CUSTOMER_MANUAL_AMOUNT", value);
      },
    },
    discountAmount: {
      get: function () {
        return this.GetCustomerDiscountForTotalAmount;
      },
      set(value) {
        this.$store.commit("bill/SET_CUSTOMER_DISCOUNT_AMOUNT", value);
        this.payments[0].amount = this.totalAmountMinusDiscount;
      },
    },
    finalAmount: {
      get: function () {
        return (
          this.GetCustomerManualAmount - this.GetCustomerCashAmount
          // -
          // parseFloat(this.GetCustomerDiscountForTotalAmount)
        );
      },
    },
    addedAmountTotal: function () {
      if (this.payments.length == 1) {
        return this.payments[0].amount;
      } else {
        var total = this.payments.reduce(function (a, b) {
          return parseInt(a) + parseInt(b.amount);
        }, 0);
        return total;
      }
    },
    totalAmount: {
      get: function () {
        if (this.isRoundingAmount) {
          return this.roundingAmount;
        }
        return this.GetTotalAmount;
      },
      set: function (value) {
        this.$store.commit("bill/SET_ROUNDING_AMOUNT", value);
      },
    },
    isSalesTypeDisabled: {
      get: function () {
        if (this.GetSelectedCustomer && this.GetSelectedCustomer.id == 1) {
          this.payingByOptions = ["Cash", "Card", "Other"];
          return true;
        }
        this.payingByOptions = ["Cash", "Card", "Cheque", "Other"];
        return false;
      },
    },
    totalDiscount: function () {
      if (
        this.GetDiscountAmount != 0 ||
        this.GetCustomerDiscountForTotalAmount != 0
      ) {
        var value =
          parseFloat(this.GetDiscountAmount) +
          parseFloat(this.GetCustomerDiscountForTotalAmount);
        return value;
      }
      return 0;
    },
    totalAmountMinusDiscount: function () {
      return (
        this.GetTotalAmount +
        this.GetServiceTotalAmount -
        parseFloat(this.GetCustomerDiscountForTotalAmount)
      );
    },
  },
  // watch: {
  //   saleTypes: {
  //     handler(val) {
  //       console.log('tttttttttttttttttttttttttttttttttttttttttttttttttttt');
  //       console.log(val);
  //
  //       if(val=='Credit'){
  //         this.payingByOptions= ["Cash", "Card", "Cheque", "Other"]
  //       }else{
  //         this.payingByOptions= ["Cash", "Card", "Other"]

  //       }
  //     },
  //     deep: true,
  //   },
  // },
  created: function () {
    this.commitPayments();
  },
  methods: {
    onOpenCustomerSalesModal() {
      this.$refs.onOpenSale.showModal();
    },
    cashBalance(value) {
      return parseInt(value);
    },
    isValid() {
      this.$v.$touch();

      let status = false;

      status = !this.$v.$invalid;
      // this.$emit('valid', status)

      if (status) {
        return true;
      } else {
        return false;
      }
    },
    showCanelModal() {
      this.$refs["my-modal"].show();
    },
    hideCanelModal() {
      this.$refs["my-modal"].hide();
    },
    cancelSale() {
      this.$store
        .dispatch("bill/cancelSale", {
          id: this.GetAddedSale.id,
          status: "Canceled",
          status_note: "Canceled test",
        })
        .then((res) => {
          this.showToast("Sales Canceled", "Success");
          this.hideCanelModal();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onChangeSaleType(value) {
      this.$store.commit("bill/SET_SALE_TYPE", value);
    },
    commitPayments() {
      this.$store.commit("bill/SET_PAYMENTS", this.payments);
    },
    // setCustomerAmount(value) {
    //   this.$store.commit("bill/SET_CUSTOMER_MANUAL_AMOUNT", value);
    // },
    calculateBalance(index) {
      var payments = _.cloneDeep(this.payments);
      // payments.splice(index, 1);

      payments[index + 1].amount = 0;
      var total = payments.reduce(function (a, { amount }) {
        return parseInt(a) + parseInt(amount);
      }, 0);

      if (this.payments.length - 1 > index) {
        this.payments[index + 1].amount =
          parseInt(this.GetTotalAmount) - parseInt(total);
      }
      this.commitPayments();
    },
    enableDisableNote(index) {
      this.payments[index].haveNote = !this.payments[index].haveNote;
      if (!this.payments[index].haveNote) {
        this.payments[index].payment_note = "";
      }
    },
    selectBiller(payload) {
      this.$store.commit("bill/SET_BILLER", payload);
    },
    addAnotherOption(index) {
      this.payments.push({
        amount: 0,
        payment_type: "Cash",
        haveNote: false,
        payment_note: "",
      });
      this.calculateBalance(index);
    },
    removeOption(index) {
      this.payments[index - 1].amount =
        parseInt(this.payments[index - 1].amount) +
        parseInt(this.payments[index].amount);
      this.payments.splice(index, 1);
    },
    Payment() {
      // ;
      if (this.GetTotalAmount + this.GetServiceTotalAmount == 0) {
        return;
      }

      this.loading = true;
      // Amount validation checks
      this.amountState = null;

      if (this.GetSaleType == "Cash") {
        if (
          parseFloat(this.GetTotalAmount) +
            parseFloat(this.GetServiceTotalAmount) -
            parseFloat(this.GetCustomerDiscountForTotalAmount) !==
          parseFloat(this.addedAmountTotal)
        ) {
          this.amountState = false;
          this.loading = false;
          return;
        } else {
          this.amountState = true;
        }
      }

      // if (this.GetTotalAmount != this.addedAmountTotal) {
      //   this.amountState = false;
      //   this.loading = false;
      //   return;
      // } else {
      //   this.amountState = true;
      // }

      var payments = [];
      for (var x = 0; x < this.payments.length; x++) {
        payments[x] = _.cloneDeep(this.payments[x]);
        delete payments[x].haveNote;
      }

      this.$store
        .dispatch("bill/submitSale", payments)
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.tab = 1;

            this.$store.commit("bill/SET_BILL_PRODUCTS_TO_PRINT_DATA");
            this.payments = [
              {
                amount: 0,
                payment_type: "Cash",
                haveNote: false,
                payment_note: "",
              },
            ];

            this.$store.dispatch("shops/fetchCashflowData");
          } else {
            this.showToast("Sales Failed", "Success");
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant: variant,
        solid: true,
      });
    },
    createUser() {},
    hideModal() {},
    showModal() {
      this.tab = 1;
      //   this.fetchProduct();
      this.$refs["paymentModal"].show();
    },
    setAmount(data) {
      this.payments[0].amount = data;
    },
    hideModal() {
      this.$refs["customer-view-modal"].hide();
    },
    setTabNum(value) {
      this.tab = value;
    },
    onChangeSidebar(status) {
      if (this.isPrint && status == false) {
        this.$store.commit("bill/CLEAR_ALL_BILL");
      }
    },
  },
};
</script>

<style>
.btn_add_another_payment {
  padding: 2px 20px;
  font-size: 12px;
  border-radius: 5px;
  width: 50%;
}

.input_Amount {
  width: 2rem !important;
}
.total_amount_area {
  background: #063232;
  color: white;
  border: unset !important;
}

.total_discount_area {
  background: #0d6666;
  color: white;
  border: unset !important;
}

.total_discount_area span {
  font-size: 14px;
}

.subtotal_area {
  background: #13928e;
  color: white;
  border: unset !important;
}

.subtotal_area span {
  font-size: 14px;
}
</style>
